import { Routes } from '@angular/router';
import { AuthenticationComponent } from './authentication/authentication.component';
import { HomeComponent } from './home/home.component';
import { EncountersComponent } from './encounters/encounters.component';
import { SettingsComponent } from './settings/settings.component';
import { AiBlueprintsComponent } from './ai-blueprints/ai-blueprints.component';
import { AiBlueprintEditorComponent } from './ai-blueprints/ai-blueprint-editor/ai-blueprint-editor.component';
import { EncounterComponent } from './encounter/encounter.component';
import { DocumentComponent } from './document/document.component';
import { FirstLoginComponent } from './first-login/first-login.component';
import { UploadComponent } from './upload/upload.component';
import { authGuard, guestGuard } from './_guards/auth.guard';
import { aiBlueprintsGuard } from './_guards/ai-blueprints.guard';
import { aiBlueprintGuard } from './ai-blueprints/guards/ai-blueprint.guard';
import { documentGuard } from './document/guards/document.guard';
import { recordingGuard } from './_guards/recording.guard';
import { unsavedChangesGuard } from './_guards/unsaved-changes.guard';
import { MdrInformationComponent } from './mdr-information/mdr-information.component';
import { firstLoginGuard, firstLoginRedirectGuard } from './first-login/first-login.guard';
import { PublicLayoutComponent } from './layouts/public-layout/public-layout.component';
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';

export const routes: Routes = [
  { path: '', 
    redirectTo: '/home', 
    pathMatch: 'full' 
  },
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      {
        path: 'login',
        component: AuthenticationComponent,
        canActivate: [guestGuard],
      },
      {
        path: 'first-login',
        component: FirstLoginComponent,
        canActivate: [authGuard, firstLoginGuard],
      },
    ],
  },
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [authGuard, firstLoginRedirectGuard],
      },
      {
        path: 'upload',
        component: UploadComponent,
        canActivate: [authGuard, firstLoginRedirectGuard],
      },
      {
        path: 'upload/:id',
        component: UploadComponent,
        canActivate: [authGuard, firstLoginRedirectGuard],
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'encounters',
        component: EncountersComponent,
        canActivate: [authGuard, firstLoginRedirectGuard],
      },
      {
        path: 'settings',
        component: SettingsComponent,
        canActivate: [authGuard, firstLoginRedirectGuard],
      },
      {
        path: 'ai-blueprints',
        component: AiBlueprintsComponent,
        canActivate: [authGuard, firstLoginRedirectGuard, aiBlueprintsGuard],
      },
      {
        path: 'ai-blueprints/new',
        component: AiBlueprintEditorComponent,
        canActivate: [authGuard, firstLoginRedirectGuard, aiBlueprintsGuard],
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'ai-blueprints/:id',
        component: AiBlueprintEditorComponent,
        canActivate: [authGuard, firstLoginRedirectGuard, aiBlueprintsGuard, aiBlueprintGuard],
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'encounter/:_id',
        component: EncounterComponent,
        canActivate: [authGuard, firstLoginRedirectGuard],
        canDeactivate: [recordingGuard],
        data: {
          hideSidebar: true,
        },
      },
      {
        path: 'document/:_id',
        component: DocumentComponent,
        canActivate: [authGuard, firstLoginRedirectGuard, documentGuard],
      },
      {
        path: 'information',
        component: MdrInformationComponent,
        canActivate: [authGuard],
      },
    ],
  },
];
